"use client";

import React from "react";
import { Instagram, MessageSquare, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-sans">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const appLinks = [{
    label: "Europa: FIAT / NEW HOLLAND / CASE",
    href: "/HomePage"
  }, {
    label: "Japón: HITACHI / KOBELCO",
    href: "/HomePage"
  }, {
    label: "Corea: DOOSAN / HYUNDAI",
    href: "/HomePage"
  }];
  const socialLinks = [{
    label: "WhatsApp Directo",
    href: "https://wa.me/34607956075",
    icon: MessageSquare
  }, {
    label: "Instagram",
    href: "https://instagram.com/recambiosmaquinaria",
    icon: Instagram
  }, {
    label: "Consultas Email",
    href: "mailto:info@conbarcelona.com",
    icon: Send
  }];
  return <section data-section-id="252377" id="pie-de-página-industrial" className="bg-background text-foreground pt-12 pb-8">
      <div className="container mx-auto px-4 max-w-7xl">
        <Separator className="mb-12 bg-secondary" />
        
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {}
          <div className="flex flex-col gap-4">
            <Link to="/" className="inline-block w-fit">
              <WvcLogo className="h-16 w-auto text-primary" />
            </Link>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed font-sans">© 2026 Recambios Maquinaria.<br />Web perteneciente a la empresa Connecting Barcelona SL<br />43300 - MONT-ROIG DEL CAMP (TARRAGONA)<br /><br /></p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold mb-5 uppercase tracking-tight text-lg text-primary">TELÉFONO: +34 607956075<br /><br />E-Mail: INFO@CONBARCELONA.COM</h3>
            <MenuProvider menu_id="46">
              <FooterNavigation />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground mb-5 uppercase tracking-tight text-lg">
              Marcas Principales
            </h3>
            <ul className="space-y-3">
              {appLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-sans">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-foreground mb-5 uppercase tracking-tight text-lg">
              Contacto Rápido
            </h3>
            <ul className="space-y-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <li key={i} data-index={i}>
                    <Link to={social.href} className="group flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors duration-200 font-sans">
                      <Icon className="size-4 text-primary transition-transform duration-200 group-hover:-translate-y-0.5" />
                      <span>{social.label}</span>
                    </Link>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}